import { render } from "./Products.vue?vue&type=template&id=08d4d846&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=08d4d846&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d4d846"]])

export default __exports__